export const SERVED_ITEM_SETUP_FETCHING = 'SERVED_ITEM_SETUP_FETCHING';
export const SERVED_ITEM_SETUP_FETCH_ERROR = 'SERVED_ITEM_SETUP_FETCH_ERROR';
export const SERVED_ITEM_SETUP_GET_DATA = 'SERVED_ITEM_SETUP_GET_DATA';



// WEBPACK FOOTER //
// ./src/pages/serveditemsetup/state/serveditemsetup/types.js